// export default { launch: "http://localhost:5000/api" }
export default { launch: "/api" }

